/** Picks the equipment image for a strength-gain row. */
const ICONS = {
  dumbbell: 'dumbbell', barbell: 'barbell', cable: 'cable', machine: 'machine',
  kettlebell: 'kettlebell', smith: 'smith', ez_bar: 'ez_bar', trap_bar: 'trap_bar',
  landmine: 'landmine', lever: 'lever', sled: 'sled', band: 'band',
  suspension: 'suspension', weighted: 'weighted', bodyweight: 'bodyweight',
  rings: 'suspension', medicine_ball: 'weighted', battle_rope: 'band',
  stick: 'barbell', wrist_roller: 'weighted',
};

// Fallback when the exercise isn't in the library: read the kit from its name.
const NAME_HINTS = [
  [/\btrap ?bar|hex ?bar\b/i, 'trap_bar'],
  [/\bez[ -]?bar|ez[ -]?curl\b/i, 'ez_bar'],
  [/\bsmith\b/i, 'smith'],
  [/\blandmine\b/i, 'landmine'],
  [/\bsled\b/i, 'sled'],
  [/\bcable|pulley|lat pulldown\b/i, 'cable'],
  [/\bdumbbell|\bdb\b/i, 'dumbbell'],
  [/\bbarbell|\bbb\b/i, 'barbell'],
  [/\bkettlebell|\bkb\b/i, 'kettlebell'],
  [/\bband\b/i, 'band'],
  [/\bsuspension|trx|ring\b/i, 'suspension'],
  [/\bmachine|press machine|leg press\b/i, 'machine'],
  [/\blever\b/i, 'lever'],
  [/\bweighted\b/i, 'weighted'],
  [/\bpull[- ]?up|chin[- ]?up|dip|push[- ]?up\b/i, 'bodyweight'],
];

export function gainIcon(equipment, exerciseName = '') {
  const key = ICONS[(equipment || '').toLowerCase()];
  if (key) return `/gains/${key}.webp`;
  const hit = NAME_HINTS.find(([re]) => re.test(exerciseName));
  return `/gains/${hit ? hit[1] : 'title'}.webp`;
}
